import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/Button';
import { Input } from '../components/Input';
export function LoginScreen() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Simulate login success
    alert('Login successful!');
    navigate('/profile');
  };
  return <div className="h-screen w-full flex flex-col bg-[#f8f9fa]" data-id="element-594">
      {/* Header */}
      <div className="bg-white px-4 py-4 flex items-center justify-between shadow-sm" data-id="element-595">
        <button onClick={() => navigate(-1)} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-596">
          <XIcon className="w-6 h-6 text-[#1f5070]" data-id="element-597" />
        </button>
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fYmeFB35HhojatJVz8XpFb/PickleballBruneiLogoC.webp" alt="Pickleball Brunei" className="h-6 object-contain" data-id="element-598" />
        <div className="w-10" data-id="element-599"></div>
      </div>

      <div className="flex-1 overflow-auto px-6 py-8" data-id="element-600">
        <div className="max-w-md mx-auto" data-id="element-601">
          {/* Logo */}
          <div className="flex justify-center mb-8" data-id="element-602">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fYmeFB35HhojatJVz8XpFb/PickleballBruneiLogoC.webp" alt="Pickleball Brunei" className="h-20 object-contain" data-id="element-603" />
          </div>

          {/* Header */}
          <div className="mb-8 text-center" data-id="element-604">
            <h2 className="text-3xl font-bold text-[#1f5070] mb-2" data-id="element-605">
              Welcome Back
            </h2>
            <p className="text-[#666666]" data-id="element-606">
              Enter your credentials to access your account
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-607">
            <Input label="Email" type="email" placeholder="your@email.com" value={email} onChange={setEmail} required data-id="element-608" />

            <Input label="Password" type="password" placeholder="••••••••" value={password} onChange={setPassword} required data-id="element-609" />

            <div className="flex items-center justify-between text-sm" data-id="element-610">
              <label className="flex items-center gap-2 cursor-pointer" data-id="element-611">
                <input type="checkbox" className="w-4 h-4 text-[#3dc7e3] border-gray-300 rounded focus:ring-[#3dc7e3]" data-id="element-612" />
                <span className="text-[#666666]" data-id="element-613">Remember me</span>
              </label>
              <button type="button" onClick={() => alert('Password reset link sent to your email!')} className="text-[#3dc7e3] hover:text-[#2db5d1] font-medium" data-id="element-614">
                Forgot password?
              </button>
            </div>

            <Button variant="primary" fullWidth className="mt-6" type="submit" data-id="element-615">
              Sign In
            </Button>
          </form>

          {/* Divider */}
          <div className="flex items-center gap-4 my-8" data-id="element-616">
            <div className="flex-1 h-px bg-gray-300" data-id="element-617"></div>
            <span className="text-sm text-gray-500" data-id="element-618">OR</span>
            <div className="flex-1 h-px bg-gray-300" data-id="element-619"></div>
          </div>

          {/* Social login */}
          <div className="space-y-3" data-id="element-620">
            <button onClick={() => alert('Google sign-in coming soon!')} className="w-full p-3 border-2 border-gray-300 rounded-lg flex items-center justify-center gap-3 hover:bg-gray-50 active:scale-98 transition-all" data-id="element-621">
              <svg className="w-5 h-5" viewBox="0 0 24 24" data-id="element-622">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-623" />
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-624" />
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-625" />
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-626" />
              </svg>
              <span className="text-[#1f5070] font-medium" data-id="element-627">
                Continue with Google
              </span>
            </button>

            <button onClick={() => alert('Facebook sign-in coming soon!')} className="w-full p-3 border-2 border-gray-300 rounded-lg flex items-center justify-center gap-3 hover:bg-gray-50 active:scale-98 transition-all" data-id="element-628">
              <svg className="w-5 h-5" fill="#1877F2" viewBox="0 0 24 24" data-id="element-629">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-630" />
              </svg>
              <span className="text-[#1f5070] font-medium" data-id="element-631">
                Continue with Facebook
              </span>
            </button>
          </div>

          {/* Register link */}
          <div className="text-center mt-8" data-id="element-632">
            <p className="text-sm text-[#666666]" data-id="element-633">
              Don't have an account?{' '}
              <button onClick={() => alert('Registration coming soon!')} className="text-[#3dc7e3] hover:text-[#2db5d1] font-bold" data-id="element-634">
                Create Account
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>;
}